import React, { useCallback, useContext, useState } from 'react';

import { AffiliateOfferContext } from 'modules/offers/context/AffiliateOfferContext';
import { ConversionFunnelBE } from 'modules/offers/models';

import Footer from '../components/Footer';
import {
  Container,
  SuccessStories,
  Wrapper,
} from '../components/StyledElements';
import WellnessSection from '../components/WellnessSection';
import useCreateRefsForClick, {
  handlerRefClick,
} from '../hooks/useCreateRefsForClick';
import { Device } from '../models';
import PreviewHeader from '../PreviewHeader';

import CheckoutSection from './components/CheckoutSection';
import EmailSection from './components/EmailSection';
import IntroSection from './components/IntroSection';

type Props = {
  chosenDevice: Device;
  closePreview: () => void;
};

const PreviewPageAffiliate = ({ chosenDevice, closePreview }: Props) => {
  const {
    offerDraft: {
      settings: {
        offerStage: { bodyText, affiliateStatement, intro },
        settingsStage: { conversionFunnel },
      },
    },
    image,
  } = useContext(AffiliateOfferContext);
  const { refs } = useCreateRefsForClick(3);

  const [activeDevice, setActiveDevice] = useState(chosenDevice);

  const isTablet = activeDevice === Device.Tablet;
  const isMobile = activeDevice === Device.Mobile;
  const isDesktop = activeDevice === Device.Desktop;

  const changeActiveDeice = useCallback(
    (device: Device) => setActiveDevice(device),
    []
  );

  return (
    <Container>
      <PreviewHeader
        title="offer"
        activeDevice={activeDevice}
        closePreview={closePreview}
        setActiveDevice={changeActiveDeice}
      />
      <Wrapper $isMobile={isMobile} $isTablet={isTablet}>
        <IntroSection
          title={affiliateStatement}
          intro={intro}
          body={bodyText}
          image={image}
          isMobile={isMobile}
          isTablet={isTablet}
          onTryForFreeClick={handlerRefClick(refs[2])}
        />
        <WellnessSection
          goToNextSection={handlerRefClick(refs[1])}
          isMobile={isMobile}
        />
        <SuccessStories
          ref={refs[1]}
          title="Trusted by 1000’s of people like you"
          isMobile={isMobile}
          isTablet={isTablet}
          $isDesktop={isDesktop}
        />
        {conversionFunnel === ConversionFunnelBE.App ? (
          <EmailSection ref={refs[2]} isMobile={isMobile} />
        ) : (
          <CheckoutSection ref={refs[2]} isMobile={isMobile} />
        )}
        <Footer isMobile={isMobile} />
      </Wrapper>
    </Container>
  );
};

export default PreviewPageAffiliate;
